module.exports = __webpack_public_path__ + "scripts/icons.ttf?f14c3b2f";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/icons.ttf
// module id = 1488
// module chunks = 1